// Angular 2
import '@angular/platform-browser';
import '@angular/platform-browser-dynamic';
import '@angular/core';
import '@angular/common';
import '@angular/http';
import '@angular/router';

import 'rxjs';
import '@angularclass/hmr';

import 'nouislider';
// import 'ng2-nouislider';

// Other vendors for example jQuery, Lodash or Bootstrap
// You can import js, ts, css, sass, ...

// jQuery is imported as a dependancy in webpack
// import 'jquery';

// import './node_modules/bootstrap-sass/assets/javascripts/bootstrap/affix';
// import './node_modules/bootstrap-sass/assets/javascripts/bootstrap/alert';
// import './node_modules/bootstrap-sass/assets/javascripts/bootstrap/button';
import './node_modules/bootstrap-sass/assets/javascripts/bootstrap/carousel';
import './node_modules/bootstrap-sass/assets/javascripts/bootstrap/collapse';
import './node_modules/bootstrap-sass/assets/javascripts/bootstrap/dropdown';
import './node_modules/bootstrap-sass/assets/javascripts/bootstrap/modal';
// import './node_modules/bootstrap-sass/assets/javascripts/bootstrap/popover';
// import './node_modules/bootstrap-sass/assets/javascripts/bootstrap/scrollspy';
// import './node_modules/bootstrap-sass/assets/javascripts/bootstrap/tab';
// import './node_modules/bootstrap-sass/assets/javascripts/bootstrap/tooltip';
import './node_modules/bootstrap-sass/assets/javascripts/bootstrap/transition';

import './old_scripts/general.js';
import './old_scripts/get-quote.js';
// import './old_scripts/wNumb';
// import './old_scripts/index';



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./resources/themes/pandax/bobtail/vendor.ts